import React, { useEffect, useState } from "react";
import { MultiSelect } from "primereact/multiselect";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import DropDownField from "../../Shared/DropdownField";
import TextField from "../../Shared/TextField";
import TextAreaField from "../../Shared/TextAreaField";
import { DisplayMsg } from "../../services/toastService";
import { keyRestrict, PostData } from "../../utils/array";
import { CLIENT_SEARCH_FILTERS } from "../../constants/clientSearchFilters";
import {
  setClientApiKey,
  setClientPlanDetail,
  setCurrentClientDetail,
  setCurrentEntityId,
  setSearchFrom,
} from "../../store/reducers/SharedLayoutDataSlice";
import { setUrl } from "../../handlers";

const ClientDetail = (props) => {
  const dispatch = useDispatch();
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const navigate = useNavigate();
  const [ImpManagerOptions, setImpManagerOptions] = useState([]);
  const [stageOptions, setStageOptions] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const [clientDetail, setClientDetail] = useState();

  const [details, setDetails] = useState({
    TrialEnd: "",
    BuyDate: "",
    healthColor: "",
  });
  const [Trigger, setTrigger] = useState({
    accountChk: false,
    alert: false,
    updateClient: false,
    dateChk: false,
    liveChk: false,
    timeZone: true,
    ImpContact: true,
    multiSelect: false,
    trialDate: false,
    inputBox: false,
    pricing: false,
    product: false,
    payment: true,
    salesPerson: false,
    impChk: true,
    cordinatorChk: true,
    flatRate: false,
    flatQnty: false,
    provider: false,
    services: false,
    rcm: false,
    sales: false,
  });
  const [showBtn, setShowBtn] = useState({
    update: false,
    calculate: false,
    practice: false,
    salePerson: false,
  });

  const [ErrorInfo, setErrorInfo] = useState({
    ACCOUNT_TYPE: false,
    NO_OF_PROVIDERS: false,
    FLAT_RATE: false,
    FLAT_QTY: false,
  });
  const AdditionalProduct = [
    { name: "Kiosk", code: "Kiosk" },
    { name: "Telehealth", code: "Telehealth" },
  ];

  useEffect(() => {
    FetchClientDetail();

    FetchClientApiKey();

    const keyUpHandler = (event) => {
      if (
        event.target.name === "TRIAL_END_DATE" ||
        event.target.name === "PAID_DATE" ||
        event.target.name === "NEXT_BILLING_DATE" ||
        event.target.name === "LIVE_DATE" ||
        event.target.name === "EXPECTED_LIVE_DATE"
      ) {
        if (event.srcElement.value.length <= 10) {
          if (event.srcElement.value === "") {
            setDetails((dateInfo) => ({
              ...dateInfo,
              [event.target.name]: null,
              [`${event.target.name}_` + `VALUE`]: "",
            }));
          } else {
            setDetails((dateInfo) => ({
              ...dateInfo,
              [event.target.name]: event.srcElement.value,
            }));
          }
        } else {
          const updatedDate = event.srcElement.value.slice(0, 10);
          setDetails((dateInfo) => ({
            ...dateInfo,
            [event.target.name]: updatedDate,
          }));
        }

        setTrigger((triggerField) => ({
          ...triggerField,
          updateClient: true,
        }));
      }
    };

    document.addEventListener("keyup", keyUpHandler);

    return () => {
      document.removeEventListener("keyup", keyUpHandler);
    };
  }, [props]);

  const FetchClientApiKey = async () => {
    const data = {
      filter: `A.SEQ_NUM =${sharedData.currentClientId}`,
      paymentGateway: "",
      hostName: "",
      userName: "",
    };
    const response = await PostData(`Clients/AuthClients`, data, "auth");
    if (response && response.succeeded) {
      const clientInfo = response.data[0];
      if (clientInfo) {
        dispatch(setClientApiKey(clientInfo.apiKey));
      }
    }
  };

  const FetchClientDetail = () => {
    try {
      const data = new FormData();
      data.append("seqNum", props?.clientId);
      document.getElementById("loader").style.display = "block";
      fetch(setUrl("CLIENTDETAIL", "LOAD", true), {
        method: "POST",
        body: data,
      })
        .then((response) => response.json())
        .then((json) => {
          if (json.status) {
            const clientData = json.Data[0];
            dispatch(setCurrentClientDetail(clientData));
            dispatch(setCurrentEntityId(clientData?.ENTITY_SEQ_NUM));
            setClientDetail(clientData);
            props.parentCallback(json.showPracticeSetup);
            for (const item in clientData) {
              if (
                item === "TRIAL_END_DATE" ||
                item === "PAID_DATE" ||
                item === "EXPECTED_LIVE_DATE" ||
                item === "NEXT_BILLING_DATE" ||
                item === "LIVE_DATE"
              ) {
                if (
                  clientData[item] !== null &&
                  clientData[item] !== "0001-01-01T00:00:00"
                ) {
                  setDetails((prevInfo) => ({
                    ...prevInfo,
                    [item]: new Date(clientData[item]),
                    [`${item}_` + `VALUE`]: new Date(
                      clientData[item]
                    ).toLocaleDateString("en-us"),
                  }));
                } else {
                  setDetails((prevInfo) => ({
                    ...prevInfo,
                    [item]: null,
                    [`${item}_` + `VALUE`]: "",
                  }));
                }
              } else if (item === "Health_Score") {
                if (clientData[item] !== null) {
                  const data = CLIENT_SEARCH_FILTERS.HEALTH_SCORE_OPTIONS.find(
                    (data) => data.value === clientData[item]
                  );
                  if (data !== null && data !== undefined) {
                    setDetails((prevDetail) => ({
                      ...prevDetail,
                      healthColor: data.color,
                      [item]: clientData[item],
                    }));
                  }
                }
              } else {
                setDetails((prevInfo) => ({
                  ...prevInfo,
                  [item]: clientData[item],
                }));
              }
            }

            const planDetail =
              json.EntityPlanData[0] != null ? json.EntityPlanData[0] : null;
            dispatch(setClientPlanDetail(planDetail));
            sessionStorage.setItem("EHRFee", json.EHRFee);
            sessionStorage.setItem("EHRPMFee", json.EHRPMFee);
            sessionStorage.setItem("PMFee", json.PMFee);
            sessionStorage.setItem("TelehealthFee", json.TelehealthFee);
            sessionStorage.setItem("KioskFee", json.KioskFee);
            sessionStorage.setItem("EHRFeeMonthly", json.EHRFeeMonthly);
            sessionStorage.setItem("EHRPMFeeMonthly", json.EHRPMFeeMonthly);
            sessionStorage.setItem("PMFeeMonthly", json.PMFeeMonthly);
            sessionStorage.setItem(
              "TelehealthFeeMonthly",
              json.TelehealthFeeMonthly
            );
            sessionStorage.setItem("KioskFeeMonthly", json.KioskFeeMonthly);

            if (stageOptions.length < 2) {
              LoadStageOptions(clientData.STAGE);
            }

            if (ImpManagerOptions.length < 1) {
              LoadImpManagerOptions(clientData.IMPLEMENTATION_MANAGER);
            }
            SetPricingModel(clientData.PRICING_MODEL);

            if (
              clientData.ADDITIONAL_PRODUCTS !== "" &&
              clientData.ADDITIONAL_PRODUCTS !== null
            ) {
              let temp = [];
              temp = clientData.ADDITIONAL_PRODUCTS.split(",");
              temp.forEach((item) => {
                const product = {
                  name: item,
                  code: item,
                };
                if (item.length > 1) {
                  setSelectedProducts((prevProduct) => [
                    ...prevProduct,
                    product,
                  ]);
                }
              });
            } else {
              setSelectedProducts(null);
            }

            if (clientData.ACCOUNT_TYPE === "PRODUCTION") {
              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                accountChk: true,
              }));
            }

            if (clientData.ACCOUNT_TYPE === "LIVE") {
              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                accountChk: true,
                liveChk: false,
              }));
            } else {
              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                accountChk: true,
                liveChk: true,
              }));
            }

            if (sessionStorage.type.toUpperCase() === "M") {
              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                impChk: false,
                accountChk: false,
              }));
              if (
                clientData.ACTIVE_FLAG.toUpperCase() !== "Y" &&
                sessionStorage.type.toUpperCase() !== "M"
              ) {
                setTrigger((triggerInfo) => ({
                  ...triggerInfo,
                  accountChk: true,
                }));
              } else if (
                (clientData.ACCOUNT_TYPE.toUpperCase() === "INACTIVE" ||
                  clientData.ACCOUNT_TYPE.toUpperCase() === "LIVE") &&
                sessionStorage.type.toUpperCase() !== "M"
              ) {
                setTrigger((triggerInfo) => ({
                  ...triggerInfo,
                  accountChk: true,
                }));
              }

              if (clientData.ACCOUNT_TYPE === "TRIAL") {
                setTrigger((triggerInfo) => ({
                  ...triggerInfo,
                  accountChk: false,
                }));
              }

              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                sales: false,
                timeZone: false,
              }));
              setShowBtn((btnChk) => ({
                ...btnChk,
                update: true,
              }));
            }

            if (sessionStorage.type.toUpperCase() === "IT") {
              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                accountChk: false,
                timeZone: false,
              }));
            }
            if (
              sessionStorage.viewOnly.toUpperCase() === "N" &&
              (sessionStorage.type.toUpperCase() === "CS" ||
                sessionStorage.type.toUpperCase() === "CSM") &&
              sessionStorage.fullAccess.toUpperCase() === "Y"
            ) {
              setShowBtn((btnChk) => ({
                ...btnChk,
                update: true,
              }));
              if (
                sessionStorage.type.toUpperCase() === "M" ||
                sessionStorage.type.toUpperCase() === "CSM" ||
                sessionStorage.type.toUpperCase() === "I" ||
                sessionStorage.type.toUpperCase() === "CS"
              ) {
                setShowBtn((btnChk) => ({
                  ...btnChk,
                  practice: true,
                }));
              }
              if (sessionStorage.type.toUpperCase() === "CSM") {
                setTrigger((triggerInfo) => ({
                  ...triggerInfo,
                  impChk: false,
                  ImpContact: false,
                }));
              }
            }
            if (
              sessionStorage.type.toUpperCase() === "SP" ||
              sessionStorage.type.toUpperCase() === "SA"
            ) {
              LoadPaidServices();
              if (clientData.ACCOUNT_TYPE === "TRIAL") {
                setShowBtn((btnChk) => ({
                  ...btnChk,
                  update: true,
                }));
                if (sessionStorage.type.toUpperCase() === "SP") {
                  setShowBtn((btnChk) => ({
                    ...btnChk,
                    calculate: true,
                  }));
                  setTrigger((triggerInfo) => ({
                    ...triggerInfo,
                    services: false,
                    rcm: false,
                    multiSelect: false,
                    salesPerson: true,
                    sales: true,
                    payment: false,
                    pricing: false,
                    provider: false,
                    flatRate: false,
                    flatQnty: false,
                    product: false,
                  }));
                } else {
                  setShowBtn((btnChk) => ({
                    ...btnChk,
                    calculate: false,
                  }));
                  setTrigger((triggerInfo) => ({
                    ...triggerInfo,
                    services: true,
                    rcm: true,
                    multiSelect: true,
                    salesPerson: false,
                    payment: true,
                    pricing: true,
                    flatRate: true,
                    flatQnty: true,
                    provider: true,
                    sales: false,
                    product: true,
                  }));
                }
              } else {
                setTrigger((triggerInfo) => ({
                  ...triggerInfo,
                  payment: true,
                  pricing: true,
                  provider: true,
                  flatRate: true,
                  flatQnty: true,
                  multiSelect: true,
                  product: true,
                  services: true,
                  rcm: true,
                }));
              }

              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                alert: true,
                impChk: true,
              }));
              setShowBtn((showInfo) => ({
                ...showInfo,
                salePerson: true,
              }));
            } else if (sessionStorage.type.toUpperCase() === "M") {
              setShowBtn((showInfo) => ({
                ...showInfo,
                salePerson: false,
              }));

              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                services: true,
                rcm: true,
                multiSelect: true,
                salesPerson: true,
                sales: false,
                payment: true,
                pricing: true,
                provider: true,
                flatRate: true,
                flatQnty: true,
                product: true,
              }));
            } else {
              setShowBtn((showInfo) => ({
                ...showInfo,
                salePerson: false,
              }));
            }
            if (sessionStorage.viewOnly === "Y") {
              setShowBtn((btnChk) => ({
                ...btnChk,
                update: false,
              }));
            }

            if (sessionStorage.type.toUpperCase() === "SA") {
              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                pricing: true,
                provider: true,
                flatRate: true,
                flatQnty: true,
                product: true,
                multiSelect: true,
                services: true,
                rcm: true,
              }));
            }
            if (
              clientData.ACCOUNT_TYPE === "LIVE" ||
              clientData.ACCOUNT_TYPE === "PRODUCTION"
            ) {
              setTrigger((triggerInfo) => ({
                ...triggerInfo,
                pricing: true,
                provider: true,
                flatRate: true,
                flatQnty: true,
                product: true,
                multiSelect: true,
                sales: false,
                services: true,
                rcm: true,
              }));
              if (sessionStorage.type.toUpperCase() === "M") {
                setTrigger((triggerInfo) => ({
                  ...triggerInfo,
                  trialDate: false,
                  provider: true,
                }));
              }
            }

            setTrigger((triggerInfo) => ({
              ...triggerInfo,
              rcm: true,
              services: true,
            }));
            document.getElementById("loader").style.display = "none";
          } else {
            if (json.status === false) {
              DisplayMsg("2", "Client Detail not found");
            }
            if (sharedData.CurrentTab === "inbox") {
              navigate("/inbox");
            } else if (sharedData.CurrentTab === "tickets") {
              navigate("/tickets");
            }
            document.getElementById("loader").style.display = "none";
          }
        })
        .catch((error) => {
          document.getElementById("loader").style.display = "none";
          console.log("2", error.Message);
        });
    } catch (e) {
      document.getElementById("loader").style.display = "none";
      console.log("2", "Unable to Process the Request");
    }
  };

  const LoadPaidServices = async () => {
    try {
      const formData = new FormData();
      formData.append("customerID", props?.clientId);
      document.getElementById("loader").style.display = "block";
      const response = await fetch(
        setUrl("CLIENTDETAIL", "PAIDSERVICES", true),
        {
          method: "POST",
          body: formData,
        }
      );
      const json = await response.json();
      if (json && json.status) {
        setDetails((prevDetail) => ({
          ...prevDetail,
          rcmFlow: json.rcmFlag,
        }));
        if (json.AmbirScanner === "Y" && json.callRemainder === "Y") {
          setDetails((prevDetail) => ({
            ...prevDetail,
            services: "Ambir Scanner, Call/Text Reminder",
          }));
        } else if (json.AmbirScanner === "Y") {
          setDetails((prevDetail) => ({
            ...prevDetail,
            services: "Ambir Scanner",
          }));
        } else if (json.callRemainder === "Y") {
          setDetails((prevDetail) => ({
            ...prevDetail,
            services: "Call/Text Reminder",
          }));
        }
        document.getElementById("loader").style.display = "none";
      } else {
        document.getElementById("loader").style.display = "none";
        DisplayMsg(2, json.Message);
      }
    } catch (e) {
      document.getElementById("loader").style.display = "none";
      console.log("2", "Unable to Process the Request");
    }
  };

  const LoadStageOptions = async (selectStage) => {
    try {
      const response = await fetch(
        setUrl("CLIENTDETAIL", "LOADSTAGEDROPDOWN", false),
        {
          method: "POST",
        }
      );
      const json = await response.json();
      if (json && json.Data) {
        const managerOptions = json.Data;
        const emptyData = {
          label: " - Select- ",
          value: "",
        };
        setStageOptions((prevStage) => [...prevStage, emptyData]);
        managerOptions.forEach((option, key) => {
          const stageData = {
            label: `${option.NAME}-${option.DESCRIPTION}`,
            value: option.SEQ_NUM,
          };
          if (selectStage && selectStage === option.SEQ_NUM) {
            setDetails((prevDetail) => ({
              ...prevDetail,
              STAGE: option.SEQ_NUM,
            }));
          }
          setStageOptions((prevStage) => [...prevStage, stageData]);
        });
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const LoadImpManagerOptions = async (selectImpManager) => {
    try {
      const response = await fetch(
        setUrl("CLIENTDETAIL", "LOADIMPLEMENTATIONMANAGERS", true),
        {
          method: "POST",
        }
      );
      const json = await response.json();
      const emptyData = {
        label: " - Select- ",
        value: "",
      };
      setImpManagerOptions((prevImpManager) => [...prevImpManager, emptyData]);
      if (json && json.status) {
        const managerOptions = json.Data;
        managerOptions.forEach((option, key) => {
          const managerData = {
            label:
              `${option.FIRST_NAME.toUpperCase()
              } ${option.LAST_NAME.toUpperCase()}`,
            value: option.EMAIL,
          };
          if (selectImpManager && selectImpManager === option.EMAIL) {
            setDetails((prevDetail) => ({
              ...prevDetail,
              IMPLEMENTATION_MANAGER: option.EMAIL,
            }));
          }
          setImpManagerOptions((prevImpManager) => [
            ...prevImpManager,
            managerData,
          ]);
        });
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const UpdateCheckUpdated = (curVal) => {
    if (curVal !== null) {
      setTrigger((triggerField) => ({
        ...triggerField,
        updateClient: true,
      }));
    }
  };

  const SetClientDetails = (dateValue, type) => {
    if (dateValue !== null) {
      setDetails((prevDetail) => ({
        ...prevDetail,
        [type]: new Date(dateValue),
        [`${type}_` + `VALUE`]: new Date(dateValue).toLocaleDateString("en-US"),
      }));
    } else {
      setDetails((prevDetail) => ({
        ...prevDetail,
        [type]: null,
        [`${type}_` + `value`]: "",
      }));
    }

    UpdateCheckUpdated(dateValue);
  };

  const SetPricingModel = (curPricingModel) => {
    if (curPricingModel === "F" || curPricingModel === "U") {
      setTrigger((triggerInfo) => ({
        ...triggerInfo,
        flatRate: false,
        flatQnty: false,
        provider: true,
      }));

      setErrorInfo((prevInfo) => ({
        ...prevInfo,
        NO_OF_PROVIDERS: false,
        FLAT_QTY: false,
        FLAT_RATE: false,
      }));
    }
    if (curPricingModel === "P") {
      setTrigger((triggerInfo) => ({
        ...triggerInfo,
        flatRate: true,
        flatQnty: true,
        provider: false,
      }));

      setErrorInfo((prevInfo) => ({
        ...prevInfo,
        NO_OF_PROVIDERS: false,
        FLAT_QTY: false,
        FLAT_RATE: false,
      }));
    }
    if (curPricingModel === "U") {
      setDetails((prevDetail) => ({
        ...prevDetail,
        NO_OF_PROVIDERS: "",
      }));

      setTrigger((triggerInfo) => ({
        ...triggerInfo,
        provider: true,
      }));
    }
  };

  const ShowClientUser = () => {
    if (sharedData.SearchFrom === "dashboard") {
      navigate("/dashboard");
    } else if (
      sharedData.SearchFrom === "TicketsTab" ||
      sharedData.SearchFrom === "TasksTab" ||
      sharedData.SearchFrom === "Ticket" ||
      sharedData.SearchFrom === "Task" ||
      sharedData.SearchFrom === "tickets" ||
      sharedData.SearchFrom === "ticketDetail"
    ) {
      navigate("/ticketDetail", {
        state: {
          ticketNo: sharedData.currentTicketNo,
        },
      });
      dispatch(setSearchFrom("Ticket"));
    } else if (sharedData.SearchFrom === "clients") {
      navigate("/clients");
    } else {
      navigate("/clients");
    }
  };


  const RefreshPractice = async () => {
    document.getElementById("loader").style.display = "block";
    const result = await fetch(
      setUrl("PRACTICEDETAIL", "REFRESHPRACTICEDATA", true)
    );
    const response = await result.json();
    if (response && response.status) {
      return true;
    } else {
      return false;
    }
  };


  const UpdateClientInfo = async () => {
    let check = false;
    if (Trigger.updateClient) {
      if (details.ACCOUNT_TYPE === "") {
        setErrorInfo((prevInfo) => ({
          ...prevInfo,
          ACCOUNT_TYPE: "Required",
        }));
        check = true;
      }

      if (check) {
        return;
      }

      const clientJson = JSON.stringify(details);
      let liveDateFlag = "N"; // No Change
      if (clientDetail && clientDetail.ACCOUNT_TYPE !== details.ACCOUNT_TYPE) {
        if (
          clientDetail.ACCOUNT_TYPE !== "LIVE" &&
          details.ACCOUNT_TYPE === "LIVE"
        ) {
          liveDateFlag = "U"; // Update Live Date
        } else if (
          clientDetail.ACCOUNT_TYPEE === "LIVE" &&
          details.ACCOUNT_TYPE !== "LIVE"
        ) {
          liveDateFlag = "E"; // Set Live Date to null
        }
      }
      const spuser =
        sessionStorage.type.toUpperCase() === "SP" ||
          sessionStorage.type.toUpperCase() === "SA"
          ? "Y"
          : "";

      try {
        const formData = new FormData();
        formData.append("ClientData", clientJson);
        formData.append("liveDateFlag", liveDateFlag);
        formData.append("IsSpuser", spuser);
        formData.append(
          "ADDITIONAL_PRODUCTS",
          clientDetail.ADDITIONAL_PRODUCTS
        );
        document.getElementById("loader").style.display = "block";
        const response = await fetch(setUrl("CLIENTDETAIL", "SAVE", true), {
          method: "POST",
          body: formData,
        });
        const json = await response.json();
        if (json && json.status) {
          RefreshPractice();
          DisplayMsg("1", json.Message);
        } else {
          DisplayMsg("2", json.Message);
        }
      } catch (e) {
        DisplayMsg("2", "Unable to Process the Request");
      }
    } else {
      DisplayMsg("2", "Please update Client field to Perform update operation");
    }
  };

  const AlterDateValues = (e) => {
    keyRestrict(e, "0123456789");
    if (e.target.value.length <= 10) {
      setDetails((dateInfo) => ({
        ...dateInfo,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const FieldValue = (fieldName) => {
    const fieldValue = details[fieldName] !== null ? details[fieldName] : "";
    return fieldValue;
  };

  const FieldData = (textField) => {
    const curName = textField.fieldName;
    const curValue = textField.fieldValue;

    if (curName === "Health_Score") {
      if (curValue !== "") {
        const data = CLIENT_SEARCH_FILTERS.HEALTH_SCORE_OPTIONS.find(
          (data) => data.value === curValue
        );
        if (data !== null) {
          setDetails((prevDetail) => ({
            ...prevDetail,
            healthColor: data.color,
            [curName]: data.value,
          }));
        }
      } else {
        setDetails((prevDetail) => ({
          ...prevDetail,
          healthColor: "",
          Health_Score: "",
        }));
      }
    } else {
      setDetails((prevDetail) => ({
        ...prevDetail,
        [curName]: curValue,
      }));
    }

    if (curName in ErrorInfo) {
      if (curName === "NO_OF_PROVIDERS") {
        if (curValue === "" || curValue <= 0) {
          setErrorInfo((prevInfo) => ({
            ...prevInfo,
            [curName]: curValue === "" ? "Required" : "Must be greater than 0",
          }));
        } else {
          setErrorInfo((prevInfo) => ({
            ...prevInfo,
            [curName]: false,
          }));
        }
      } else if (curName === "FLAT_RATE") {
        if (curValue === "" || curValue <= 0) {
          setErrorInfo((prevInfo) => ({
            ...prevInfo,
            [curName]: curValue === "" ? "Required" : "Must be greater than 0",
          }));
        } else {
          setErrorInfo((prevInfo) => ({
            ...prevInfo,
            [curName]: false,
          }));
        }
      } else if (curName === "FLAT_QTY") {
        if (curValue.length < 1 || curValue <= 0) {
          setErrorInfo((prevInfo) => ({
            ...prevInfo,
            [curName]: curValue === "" ? "Required" : "Must be greater than 0",
          }));
        } else {
          setErrorInfo((prevInfo) => ({
            ...prevInfo,
            [curName]: false,
          }));
        }
      } else {
        setErrorInfo((prevInfo) => ({
          ...prevInfo,
          [curName]: curValue.length < 1,
        }));
      }
    }
    UpdateCheckUpdated(curValue);
  };

  return (
    <>
      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />
      <div className="tab-content">
        <div className="tab-pane active" id="clientDetail">
          <div className="client-section">
            <div className="row">
              <div className="col-md-3 col-sm-3">
                <TextField
                  id="AUTH_ENTITY_SEQ_NUM"
                  length={255}
                  label="Customer Id:"
                  value={details.SEQ_NUM}
                  required={false}
                  disabled
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  id="PRACTICE_NAME"
                  length={255}
                  label="Practice Name:"
                  value={details.PRACTICE_NAME}
                  required={false}
                  disabled
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  id="CONTACT_PERSON"
                  length={255}
                  label="Contact Person:"
                  value={details.CONTACT_PERSON}
                  required={false}
                  disabled
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  id="PRACTICE_EMIL"
                  length={255}
                  label="Email:"
                  value={details.PRACTICE_EMIL}
                  required={false}
                  disabled
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-3">
                <div className="two-col-field-container">
                  <TextField
                    label="Tel #:"
                    value={details.PRACTICE_TEL_NUM}
                    required={false}
                    disabled
                  />
                  <TextField
                    label="Speciality:"
                    value={details.SPECIALITY}
                    required={false}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  label="Entity:"
                  value={details.ENTITY_SHORT_NAME}
                  required={false}
                  disabled
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  label="Address:"
                  value={details.PRACTICE_ADDRESS}
                  disabled
                  required={false}
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  label="City:"
                  value={details.PRACTICE_CITY}
                  disabled
                  required={false}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-3">
                <div className="two-col-field-container">
                  <TextField
                    id="PRACTICE_STATE"
                    length={255}
                    label="State:"
                    value={details.PRACTICE_STATE}
                    required={false}
                    disabled
                  />

                  <TextField
                    id="PRACTICE_ZIPCODE"
                    length={255}
                    label="Zip:"
                    value={details.PRACTICE_ZIPCODE}
                    required={false}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-3 col-sm-3">
                <DropDownField
                  id="ACCOUNT_TYPE"
                  classDiv
                  label="Account Type:"
                  disabled={Trigger.accountChk}
                  options={CLIENT_SEARCH_FILTERS.ACCOUNT_OPTIONS}
                  value={FieldValue("ACCOUNT_TYPE")}
                  ReceivedTextData={FieldData}
                  requiredMsg={ErrorInfo.ACCOUNT_TYPE}
                  bold
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  id="TRIAL_ACTIVATION_STATUS"
                  length={255}
                  label="Trial Activation Status:"
                  value={details.TRIAL_ACTIVATION_STATUS}
                  required={false}
                  disabled
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <DropDownField
                  id="SALES_PERSON"
                  bold
                  classDiv
                  label="Sales Person:"
                  required={false}
                  disabled={Trigger.sales}
                  options={sharedData.salesPersonList}
                  value={FieldValue("SALES_PERSON")}
                  ReceivedTextData={FieldData}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-3">
                <TextField
                  id="TRIAL_START_DATE"
                  length={255}
                  label="Trial Start Date:"
                  value={
                    details.TRIAL_START_DATE !== "0001-01-01T00:00:00"
                      ? moment(details.TRIAL_START_DATE).format("MM/DD/yyyy")
                      : ""
                  }
                  required={false}
                  disabled
                />
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container overflow-visible">
                  <label className="field-placeholder font-medium">
                    Trial End Date:
                  </label>
                  <DatePicker
                    value={
                      details.TRIAL_END_DATE
                        ? dayjs(details.TRIAL_END_DATE)
                        : null
                    }
                    onChange={(data) =>
                      SetClientDetails(data, "TRIAL_END_DATE")
                    }
                    name="TRIAL_END_DATE"
                    format="MM/DD/YYYY"
                    placeholder="MM/DD/YYYY"
                    disabled={Trigger.trialDate}
                    onKeyDown={(e) => AlterDateValues(e)}
                  />
                </div>
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  id="TRIAL_ACTIVATION_DATE"
                  length={255}
                  label="Trial Activation Date:"
                  value={
                    details.TRIAL_ACTIVATION_DATE !== "0001-01-01T00:00:00" &&
                      details.TRIAL_ACTIVATION_DATE !== null
                      ? moment(details.TRIAL_ACTIVATION_DATE).format(
                        "MM/DD/yyyy"
                      )
                      : ""
                  }
                  required={false}
                  disabled
                />
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container overflow-visible">
                  <label className="field-placeholder font-medium">
                    Buy Date:
                  </label>
                  <DatePicker
                    value={details.PAID_DATE ? dayjs(details.PAID_DATE) : null}
                    onChange={(data) => SetClientDetails(data, "PAID_DATE")}
                    name="PAID_DATE"
                    className="field-input"
                    format="MM/DD/YYYY"
                    placeholder="MM/DD/YYYY"
                    disabled
                    onKeyDown={(e) => AlterDateValues(e)}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3 col-sm-3">
                <div className="field-container overflow-visible">
                  <label className="field-placeholder font-medium">
                    Renewal Date:
                  </label>
                  <DatePicker
                    value={
                      details.NEXT_BILLING_DATE
                        ? dayjs(details.NEXT_BILLING_DATE)
                        : null
                    }
                    onChange={(data) =>
                      SetClientDetails(data, "NEXT_BILLING_DATE")
                    }
                    name="NEXT_BILLING_DATE"
                    className="field-input"
                    format="MM/DD/YYYY"
                    placeholder="MM/DD/YYYY"
                    disabled
                    onKeyDown={(e) => AlterDateValues(e)}
                  />
                </div>
              </div>
              <div className="col-md-3 col-sm-3">
                <div className="field-container overflow-visible">
                  <label className="field-placeholder font-medium">
                    Live Date:
                  </label>
                  <DatePicker
                    value={details.LIVE_DATE ? dayjs(details.LIVE_DATE) : null}
                    onChange={(data) => SetClientDetails(data, "LIVE_DATE")}
                    name="LIVE_DATE"
                    className="field-input"
                    format="MM/DD/YYYY"
                    placeholder="MM/DD/YYYY"
                    disabled={Trigger.liveChk}
                    onKeyDown={(e) => AlterDateValues(e)}
                  />
                </div>
              </div>

              <div className="col-md-3 col-sm-3">
                <div className="field-container overflow-visible">
                  <label className="field-placeholder font-medium">
                    Expected Live Date:
                  </label>
                  <DatePicker
                    value={
                      details.EXPECTED_LIVE_DATE
                        ? dayjs(details.EXPECTED_LIVE_DATE)
                        : null
                    }
                    onChange={(data) =>
                      SetClientDetails(data, "EXPECTED_LIVE_DATE")
                    }
                    name="EXPECTED_LIVE_DATE"
                    className="field-input"
                    format="MM/DD/YYYY"
                    placeholder="MM/DD/YYYY"
                    onKeyDown={(e) => AlterDateValues(e)}
                  />
                </div>
              </div>
              <div className="col-md-3 col-sm-3">
                <DropDownField
                  id="STAGE"
                  bold
                  classDiv
                  label="Stage:"
                  required={false}
                  disabled={Trigger.inputBox}
                  options={stageOptions}
                  value={FieldValue("STAGE")}
                  ReceivedTextData={FieldData}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-3">
                <DropDownField
                  id="IMPLEMENTATION_MANAGER"
                  bold
                  classDiv
                  label="Implementation Manager:"
                  required={false}
                  disabled={Trigger.impChk}
                  options={ImpManagerOptions}
                  value={FieldValue("IMPLEMENTATION_MANAGER")}
                  ReceivedTextData={FieldData}
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  id="IMPLEMENTATION_CONTACT"
                  length={255}
                  disabled={Trigger.impChk}
                  label="Implementation Contact"
                  ReceivedTextData={FieldData}
                  value={FieldValue("IMPLEMENTATION_CONTACT")}
                  required={false}
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <TextField
                  id="IMPLEMENTATION_COORDINATOR"
                  length={255}
                  disabled={Trigger.impChk}
                  label="Implementation Coordinator:"
                  ReceivedTextData={FieldData}
                  value={FieldValue("IMPLEMENTATION_COORDINATOR")}
                  required={false}
                />
              </div>
              <div className="col-md-3 col-sm-3">
                <DropDownField
                  id="PAYMENT_CYCLE"
                  bold
                  classDiv
                  label="Payment Cycle:"
                  required={false}
                  disabled={Trigger.payment}
                  options={CLIENT_SEARCH_FILTERS.PAYMENT_CYCLE}
                  value={FieldValue("PAYMENT_CYCLE")}
                  ReceivedTextData={FieldData}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-3">
                <DropDownField
                  id="ALERT"
                  bold
                  classDiv
                  label="Alert:"
                  required={false}
                  disabled={Trigger.alert}
                  options={CLIENT_SEARCH_FILTERS.ALERT_OPTIONS}
                  value={FieldValue("ALERT")}
                  ReceivedTextData={FieldData}
                />
              </div>

              <div className="col-md-3 col-sm-3">
                <DropDownField
                  id="TIMEZONE"
                  bold
                  classDiv
                  label="Time Zone:"
                  required={false}
                  disabled={Trigger.timeZone}
                  options={CLIENT_SEARCH_FILTERS.TIME_ZONE_OPTIONS}
                  value={FieldValue("TIMEZONE")}
                  ReceivedTextData={FieldData}
                  requiredMsg={false}
                />
              </div>

              <div className="col-md-3 col-sm-3">
                <DropDownField
                  id="Health_Score"
                  bold
                  classDiv
                  label="Health Score:"
                  color={details.healthColor}
                  required={false}
                  disabled={Trigger.inputBox}
                  options={CLIENT_SEARCH_FILTERS.HEALTH_SCORE_OPTIONS}
                  value={FieldValue("Health_Score")}
                  ReceivedTextData={FieldData}
                />
              </div>
              {showBtn.salePerson && (
                <>
                  <div className="col-md-3 col-sm-3">
                    <DropDownField
                      id="PRICING_MODEL"
                      bold
                      classDiv
                      label="Pricing Model:"
                      required={false}
                      disabled={Trigger.pricing}
                      options={CLIENT_SEARCH_FILTERS.PRICING_MODEL}
                      value={FieldValue("PRICING_MODEL")}
                      ReceivedTextData={FieldData}
                    />
                  </div>
                  <div className="col-md-3 col-sm-3">
                    <TextField
                      id="NO_OF_PROVIDERS"
                      disabled={Trigger.provider}
                      label="No Of Provider:"
                      ReceivedTextData={FieldData}
                      value={FieldValue("NO_OF_PROVIDERS")}
                      requiredMsg={ErrorInfo.NO_OF_PROVIDERS}
                    />
                  </div>
                </>
              )}
            </div>
            {showBtn.salePerson && (
              <>
                <div className="row">
                  <div className="col-md-3 col-sm-3">
                    <TextField
                      id="FLAT_RATE"
                      disabled={Trigger.flatRate}
                      label="Rate $:"
                      ReceivedTextData={FieldData}
                      value={FieldValue("FLAT_RATE")}
                      requiredMsg={ErrorInfo.FLAT_RATE}
                    />
                  </div>
                  <div className="col-md-3 col-sm-3">
                    <TextField
                      id="FLAT_QTY"
                      disabled={Trigger.flatRate}
                      label="Qty:"
                      ReceivedTextData={FieldData}
                      value={FieldValue("FLAT_QTY")}
                      requiredMsg={ErrorInfo.FLAT_QTY}
                    />
                  </div>
                  <div className="col-md-3 col-sm-3">
                    <DropDownField
                      id="PRODUCT"
                      bold
                      classDiv
                      label="Products:"
                      required={false}
                      disabled={Trigger.product}
                      options={CLIENT_SEARCH_FILTERS.PRODUCTS_DETAIL}
                      value={FieldValue("PRODUCT")}
                      ReceivedTextData={FieldData}
                    />
                  </div>

                  <div className="col-md-3 col-sm-3">
                    <div className="align-items-end field-container flex multiSelectBtn">
                      <label className="product-placeholder font-medium">
                        Additonal Products:
                      </label>
                      <MultiSelect
                        value={selectedProducts}
                        className="field-input bg-transparent"
                        options={AdditionalProduct}
                        disabled={Trigger.multiSelect}
                        showClear
                        onChange={(e) => setSelectedProducts(e.value)}
                        optionLabel="name"
                        placeholder="Select a products"
                        showSelectAll={false}
                        selectAll={false}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3 col-sm-3">
                    <TextField
                      id="services"
                      disabled={Trigger.services}
                      label="Services:"
                      ReceivedTextData={FieldData}
                      value={FieldValue("services")}
                      required={false}
                    />
                  </div>

                  <div className="col-md-3 col-sm-3">
                    <TextField
                      id="rcmFlow"
                      disabled={Trigger.rcm}
                      label="RCM workflow:"
                      ReceivedTextData={FieldData}
                      value={FieldValue("rcmFlow")}
                      required={false}
                    />
                  </div>
                </div>
              </>
            )}
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <TextAreaField
                  id="COMMENTS"
                  width
                  labelClass="field-placeholder label-top-text"
                  label="Add Comments:"
                  disabled
                  value={clientDetail?.COMMENTS}
                  rows={2}
                  cols={20}
                  length={2000}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <TextAreaField
                  id="IMPLEMENTATION_COMMENTS"
                  width
                  ReceivedTextData={FieldData}
                  labelClass="field-placeholder label-top-text"
                  label="Implementation Comments:"
                  disabled={Trigger.inputBox}
                  value={FieldValue("IMPLEMENTATION_COMMENTS")}
                  rows={2}
                  cols={20}
                  length={4000}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-2 text-center w-full">
                <input
                  type="button"
                  className={`btnLinkGreen btnUpdate ${showBtn.update ? "d-inline-block" : "d-none"
                    }`}
                  id="btnUpdate"
                  onClick={() => UpdateClientInfo()}
                  value="Update Info"
                />
                <input
                  type="button"
                  className={`btnLinkBlue show1 ${showBtn.calculate ? "d-inline-block" : "d-none"
                    }`}
                  value="Calculate"
                  id="btnCalculate"
                />
                <input
                  type="button"
                  className="btnLinkBlue"
                  id="btnCancel"
                  value="Back"
                  onClick={() => ShowClientUser()}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="tab-pane" id="clientTask" />
        <div className="tab-pane" id="clientNotes" />
      </div>
    </>
  );
};

export default ClientDetail;
